import React from 'react';
import {Text, Flex} from '@priority-software/priority-style-react';
import Lottie from 'react-lottie';
import styles from '../styles/progressBar.module.scss';
import texts from '../../texts';
import {check, downloadAnimation, uploadAnimation} from '../assets';
import {createDataTestId} from '../../../../../../utils/dataTestId';

type Props = {
    isUploading: boolean;
    isSuccess: boolean;
    filesCount: number;
    successFilesCount: number;
};

export const ProgressBar = ({isUploading, isSuccess, filesCount, successFilesCount}: Props) => {
    const animationData = isUploading ? uploadAnimation : downloadAnimation;
    const animationOptions = {
        loop: true,
        autoplay: true,
        animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return (
        <Flex
            alignItems="center"
            justifyContent="center"
            componentClasses={styles.progressBarWrapper}
        >
            <Flex
                direction="column"
                componentClasses={styles.progressBarContainer}
                {...createDataTestId(`attachments-progressBar-container`, true)}
            >
                {!isUploading && (
                    <Text skin={'paragraph-2'} componentClasses={styles.progressBarTitle}>
                        {texts.file_download}
                    </Text>
                )}
                {isSuccess ? (
                    <img
                        src={check}
                        alt="uploading"
                        className={styles.succesImg}
                        data-test-id="check-img"
                    />
                ) : (
                    <div>
                        <Lottie
                            options={animationOptions}
                            height={62}
                            width={62}
                            ariaRole="lottie-img"
                        ></Lottie>
                    </div>
                )}
                {isUploading && (
                    <Text skin={'paragraph-2'} componentClasses={styles.progressBarTitle}>
                        {isSuccess
                            ? successFilesCount > 1
                                ? texts.files_saved
                                : texts.file_saved
                            : filesCount > 1
                            ? texts.files_upload
                            : texts.file_upload}
                    </Text>
                )}
            </Flex>
        </Flex>
    );
};
